import type { TranslationMessages } from '../types';

export const salary_forecast: TranslationMessages = {
      title: 'Báo Cáo Dự Báo Lương',
      subtitle: 'Dự báo lương nhân viên dựa trên ca làm việc đã lên lịch',
      export_report: 'Xuất Báo Cáo',
      select_date_range: 'Chọn Khoảng Thời Gian',
      choose_period: 'Chọn khoảng thời gian để dự báo lương',
      generate_report: 'Tạo Báo Cáo',
      loading_report: 'Đang Tải Dự Báo Lương',
      fetching_data: 'Đang lấy dữ liệu ca làm việc và nhân viên...',
      failed_to_load: 'Không Thể Tải Báo Cáo',
      try_again_message: 'Vui lòng thử lại hoặc kiểm tra kết nối của bạn',
      total_forecasted: 'Tổng Lương Dự Báo',
      staff_members: 'nhân viên',
      total_hours: 'Tổng Giờ',
      scheduled_hours: 'Giờ đã lên lịch trong khoảng thời gian',
      average_daily: 'Lương Trung Bình Hàng Ngày',
      per_day_average: 'Trung bình mỗi ngày',
      salary_chart: 'Biểu Đồ Dự Báo Lương',
      chart_description: 'Phân tích lương dự báo hàng ngày',
      salary: 'Lương',
      hours: 'Giờ',
      staff_breakdown: 'Phân Tích Lương Theo Nhân Viên',
      staff_breakdown_description: 'Lương dự báo theo từng nhân viên',
      no_shifts_found: 'Không Tìm Thấy Ca Làm Việc',
      no_shifts_message:
        'Không tìm thấy ca làm việc đã lên lịch cho khoảng thời gian đã chọn',
      shifts: 'ca làm việc',
      daily_breakdown: 'Phân Tích Hàng Ngày',
      daily_breakdown_description: 'Phân tích lương dự báo hàng ngày',
      no_data_found: 'Không Tìm Thấy Dữ Liệu',
      no_data_message:
        'Không tìm thấy dữ liệu lương cho khoảng thời gian đã chọn',
      staff: 'nhân viên',
      full_time: 'Toàn Thời Gian',
      shift_based: 'Theo Ca',
      vacation_days: 'ngày nghỉ phép',
      unpaid_absences: 'ngày vắng không lương',
      bonuses: 'thưởng',
      vacation_pay: 'lương nghỉ phép',
      base_salary: 'Bao gồm lương cơ bản',
    };
